export const frActualites = {
    'toast.apiErrors.NEWS_MISSING_CATEGORY':
        "Aucune catégorie n'est définie pour cette actualité, elle ne peut pas être publiée",
    'toast.apiErrors.NEWS_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour cette actualité, elle ne peut pas être publiée",

    'actualites.name': 'Actualité',
    'actualites.list.sectionTitle': 'Actualités',

    // LIST
    'actualites.list.pageTitle': 'Actualités',
    'actualites.list.actions.addActualite': 'Créer une actualité',
    'actualites.list.table.emptyLabel': "Il n'y a pas d'actualité pour le moment",

    'actualites.list.table.header.info': 'Informations',

    // LIST > AUDIENCE
    'actualites.list.table.filters.favoriteShops': 'Mes centres favoris',
    'actualites.list.table.filters.apply': 'Appliquer',

    // LIST > STATE
    'actualites.list.table.filters.label.state': 'État :',
    'actualites.list.table.state.drafts': 'Brouillon',
    'actualites.list.table.state.published': 'Publié',
    'actualites.list.table.state.unpublished': 'Annulé',
    'actualites.list.table.state.finished': 'Terminé',

    'backofficeUsers.create.tabs.permissions.sectionTabs.actualites': 'Actualités',
    'backofficeUsers.permissions.actualites.contentcreate':
        "Création d'actualités",

    // CREATE
    'actualites.create.tabs.info': 'Informations',
    'actualites.create.tabs.audience': 'Audience',
    'actualites.create.tabs.notifications': 'Notifications',

    // DETAILS
    'actualites.create.pageTitle': 'Créer une actualité',
    'actualites.details.pageTitle': 'Détails actualité',

    'actualites.create.input.name': "Saisissez ici le nom de l'actualité *",
    'actualites.create.input.code': "Saisissez ici le code de l'actualité",
    'actualites.create.input.floatingLabelName': 'Nom',
    'actualites.create.input.floatingLabelCode': 'Code',
    'actualites.create.actions.addTheActualite': 'Enregistrer',

    'actualites.create.tabs.informations.inputs.description':
        "Saisissez ici la description de l'actualité",

    'actualites.details.dialog.title': "Suppression de l'actualité",
    'actualites.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette actualité ?',
    'actualites.details.dialog.validateLabel': 'Supprimer',
    'actualites.details.dialog.cancelLabel': 'Annuler',
    'actualites.details.actions.save': 'Enregistrer',
    'actualites.details.actions.remove': 'Supprimer',
    'actualites.details.actions.previous': 'Vidéos',
    'actualites.details.tabs.info': 'Informations',
    'actualites.details.tabs.audience': 'Audience',
    'actualites.details.tabs.notifications': 'Notifications',
    'actualites.details.tabs.informations.generalSectionTitle': 'Informations générales',
    'actualites.details.tabs.informations.publishSectionTitle': 'Publication',
    'actualites.details.tabs.informations.inputs.description':
        "Saisissez ici la description de l'actualité",

    'actualites.create.tabs.informations.inputs.category.hint': 'Selectionnez une catégorie',
    'actualites.create.tabs.informations.inputs.category.newsletters': 'Midas hebdo',
    'actualites.create.tabs.informations.inputs.category.product': 'Produit',
    'actualites.create.tabs.informations.inputs.category.client': 'Client',
    'actualites.create.tabs.informations.inputs.category.partnership': 'Partenariat',
    'actualites.create.tabs.informations.inputs.category.communication': 'Communication',
    'actualites.create.tabs.informations.inputs.category.challenge': 'Challenge',
    'actualites.create.tabs.informations.inputs.category.offer': 'Promotion',
    'actualites.create.tabs.informations.inputs.category.meeting': 'Réunion',
    'actualites.create.tabs.informations.inputs.category.other': 'Divers',

    // DETAILS > NOTIFICATIONS

    'actualites.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté l'actualité",

    // DETAILS > RESULTS
    'actualites.details.tabs.results.likedShopCount': 'Like :',
    'actualites.details.tabs.results.tableHeader.like': 'Like',

    'actualites.filters.like.button.label': 'Like',
    'actualites.filters.like.filterLabelName': 'Like :',
    'actualites.filters.like.filterFormat': 'Like : {value}',
    'actualites.filters.like.Answered': 'Oui',
    'actualites.filters.like.NotAnswered': 'Non',

    'actualites.details.tabs.results.like.true': 'Oui',
    'actualites.details.tabs.results.like.false': ' ',
};
